import React from "react";
import classnames from "classnames";
import styles from "./NewLabel.module.scss";

function NewLabel({ className = "" }) {
  return <div className={classnames(styles["new-label"], className)}>NEW</div>;
}

export default NewLabel;
